/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Include_FormattingInputs */



/**
* | output |
* | --- |
* | "Include Formatting" |
*
* @param {Include_FormattingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const include_formatting = /** @type {((inputs?: Include_FormattingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Include_FormattingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure la mise en forme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formatierung einschließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi formattazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить форматирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包含格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書式設定を含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉर्मेटिंग शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir formatação")
	return /** @type {LocalizedString} */ ("Include Formatting")
});